// Supplier Repository - Repository Pattern
import apiService from '../api.service';

class SupplierRepository {
  // Get all suppliers
  async getAll(params = {}) {
    return apiService.get('/suppliers', params);
  }

  // Get single supplier
  async getById(id) {
    return apiService.get(`/suppliers/${id}`);
  }

  // Create supplier
  async create(data) {
    // Check if there's an image - if so, use FormData
    if (data.image) {
      const formData = new FormData();
      Object.keys(data).forEach(key => {
        if (data[key] !== null && data[key] !== undefined) {
          formData.append(key, data[key]);
        }
      });
      return apiService.upload('/suppliers', formData);
    } else {
      // No image, use regular JSON post
      return apiService.post('/suppliers', data);
    }
  }

  // Update supplier
  async update(id, data) {
    // Check if there's an image - if so, use FormData with special route
    if (data.image) {
      const formData = new FormData();
      Object.keys(data).forEach(key => {
        if (data[key] !== null && data[key] !== undefined) {
          formData.append(key, data[key]);
        }
      });
      return apiService.upload(`/suppliers/${id}/update`, formData);
    } else {
      // No image, use regular JSON put
      return apiService.put(`/suppliers/${id}`, data);
    }
  }

  // Delete supplier
  async delete(id) {
    return apiService.delete(`/suppliers/${id}`);
  }
}

export default new SupplierRepository();